import { render, staticRenderFns } from "./IpotekaPaymentTransactionAddEditView.vue?vue&type=template&id=18527942&scoped=true&"
import script from "./IpotekaPaymentTransactionAddEditView.vue?vue&type=script&lang=js&"
export * from "./IpotekaPaymentTransactionAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./IpotekaPaymentTransactionAddEditView.vue?vue&type=style&index=0&id=18527942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18527942",
  null
  
)

export default component.exports